var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeWidth":"2.5","d":"m1 1.5 7 7 7-7"}));
}

ChevronDown.defaultProps = {"width":"16","height":"11","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
